<template>

  <v-container fluid class="page page-route-list">

    <!-- Breadcrumb -->
    <v-row class="mt-4 mb-6">
      <v-col cols="12" class="d-flex align-center justify-start page-breadcrumb-new">
        <v-icon small class="mr-2">mdi-directions-fork</v-icon>
        <div>Routes</div>
      </v-col>
    </v-row>

    <!-- Page Navigation -->
    <v-tabs fixed-tabs show-arrows class="page-navigation" v-model="activeTab">
      <v-tab @click="$root.goTo('route-list-created')">Created</v-tab>
      <v-tab @click="$root.goTo('route-list-dispatched')">Dispatched</v-tab>
      <v-tab @click="$root.goTo('route-list-on-delivery')">On Delivery</v-tab>
      <v-tab @click="$root.goTo('route-list-completed')">Completed</v-tab>
      <v-tab @click="$root.goTo('route-list-canceled')">Canceled</v-tab>
    </v-tabs>

    <!-- Page Content -->
    <v-container fluid class="px-0">
      <transition name="fade-flash" mode="out-in">
        <router-view />
      </transition>
    </v-container>

  </v-container>

</template>

<script>
export default {
  name: 'RouteListRootPage',

  data () {
    return {
      activeTab: 0 // route-list-created
    }
  },

  computed: {
    appName () {
      return this.$store.getters['app/platform']
    }
  },

  beforeMount () {
    // Set active tab
    switch (this.$route.name) {
      case 'route-list-created': this.activeTab = 0; break
      case 'route-list-dispatched': this.activeTab = 1; break
      case 'route-list-on-delivery': this.activeTab = 2; break
      case 'route-list-completed': this.activeTab = 3; break
      case 'route-list-canceled': this.activeTab = 4; break
    }
  }
}
</script>

<style>
</style>
